import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { isMobileApp } from 'utils';
import { Button } from '@mui/material';
import { QrCodeScanner } from '@mui/icons-material';
import { preventDefault } from 'shared/hooks/utils';
import { matchSerial } from 'entities/device.add/lib/match-serial';
import { useMutationCallback } from 'shared/api/hooks';
export const ScanSerial = memo(function ScanSerial(props) {
    const { setSerial, onError } = props;
    const [onFind1CSerial, loadingFind1CSerial, responseFind1CSerial, errorFind1CSerial, sendFind1CSerial,] = useMutationCallback('find_serial_1c');
    useEffect(() => {
        if (responseFind1CSerial?.ok && sendFind1CSerial) {
            setSerial(responseFind1CSerial.serial);
        }
    }, [responseFind1CSerial, sendFind1CSerial]);
    const onScanClick = useCallback((event) => {
        preventDefault(event);
        window.cordova.plugins.barcodeScanner.scan((result) => {
            if (result.cancelled) {
                return;
            }
            console.log(`Got qr-code: ${result.text}`);
            const { serial, qr_1c } = matchSerial(result.text);
            if (serial) {
                setSerial(serial);
                return;
            }
            else {
                if (qr_1c) {
                    onFind1CSerial({ qr_code_1c: qr_1c });
                    return;
                }
            }
            onError('Не удалось распознать QR-code');
        }, (error) => {
            console.log(`Failed to scan qr-code: ${error}`);
            onError(`Не удалось распознать QR-code: ${error}`);
        }, {
            resultDisplayDuration: 0,
            showFlipCameraButton: true,
            showTorchButton: true,
            prompt: 'Наведите на жёлтый QR-код\nна лицевой стороне устройства',
            formats: 'QR_CODE',
            disableAnimations: false,
        });
    }, []);
    if (!isMobileApp()) {
        return null;
    }
    if (!window.cordova?.plugins.barcodeScanner) {
        return null;
    }
    return (_jsx(Button, { onClick: onScanClick, startIcon: _jsx(QrCodeScanner, {}), variant: "contained", color: "secondary", children: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR-\u043A\u043E\u0434" }));
});
